import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ChartAccountDialog } from '../chart-accounts/chart-accounts.component';
import { ToastrService } from 'ngx-toastr';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { ChartOfAccountsService } from '../../features/chart-of-accounts/services/chart-of-accounts.service';

@Component({
  selector: 'app-chart-accounts-details',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatInputModule,
    MatTabsModule,
    RouterModule,
    // PermissionDirective
  ],
  templateUrl: './chart-accounts-details.component.html',
  styleUrl: './chart-accounts-details.component.scss'
})
export class ChartAccountsDetailsComponent {
  selectedTabIndex = 0;
  accountType: any;
  search: any;
  chartAccounts: any;
  parentAccountId: any;
  isSubAccount: any;
  accountId: any;
  accountData: any;
  readonly dialog = inject(MatDialog);
  // Permission = Permission;

  selectTab(index: number) {
    this.selectedTabIndex = index;
  }

  constructor(
    private chartAccountService: ChartOfAccountsService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
  ){}

  ngOnInit(){
    this.fetchAccounts();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {      
      this.accountId = Number(id);
      this.fetchAccountById(this.accountId); 
    }
  }
  
  fetchAccounts() {
    this.chartAccountService.fetchChartAccounts(this.search).subscribe({
      next: (accounts: any) => {
        this.chartAccounts = accounts;
        if(this.accountId) {
          this.onTabChange(this.accountId);
        }
      },
      error: (error) => { 
        console.error(error, 'Error');
      }
    })
  }

  fetchAccountById(id: any) {
    this.chartAccountService.chartOfAccountsById(id).subscribe({
      next: (data) => {
        this.accountData = data;
      },
      error: (error) => {
        console.error(error);
      }
    })
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  onTabChange(index: number) {    
    const accountId = this.chartAccounts[index]?.id;  
    if (accountId) {
      this.router.navigate(['/chart-of-accounts/chart-of-accounts-details', accountId]);
      this.fetchAccountById(accountId);
    }
  }

  onEdit() {
    const dialogRef = this.dialog.open(ChartAccountDialog, {
      disableClose: true,
      data: this.accountId,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.toastr.success('Account updated successfully', 'Success');
      }
    });
  }

}
